<docs>
# Modal

> NOTE: this docs defined at **docs** section inside Modal.vue module

Modal UI Set

<!-- STORY -->

### Example

>normal

```html
<mt-modal :visible.sync="normalModalDemoVisible" title="Title" @close="handleBeforeModalClose" @open="openModal" closeVisible="true">
  <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
  <div slot="footer">
    <mt-button size="small" type="primary" @click="normalModalDemoVisible = false">확인</mt-button>
    <mt-button size="small" type="subtle" @click="normalModalDemoVisible = false">취소</mt-button>
  </div>
</mt-modal>
```

>small

```html
<mt-modal :visible.sync="smallModalDemoVisible" size="small" title="Title" @close="handleBeforeModalClose" @open="openModal" closeVisible="true">
  <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
  <div slot="footer">
    <mt-button size="small" type="primary" @click="smallModalDemoVisible = false">확인</mt-button>
    <mt-button size="small" type="subtle" @click="smallModalDemoVisible = false">취소</mt-button>
  </div>
</mt-modal>
```

>large

```html
<mt-modal :visible.sync="largeModalDemoVisible" size="large" title="Title" @close="handleBeforeModalClose" @open="openModal" closeVisible="true">
  <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
  <div slot="footer">
    <mt-button size="small" type="primary" @click="largeModalDemoVisible = false">확인</mt-button>
    <mt-button size="small" type="subtle" @click="largeModalDemoVisible = false">취소</mt-button>
  </div>
</mt-modal>
```

### Data

| Property                     | Description             | Type     | Accepted Values              | Default     |
|------------------------------|-------------------------|----------|------------------------------|-------------|
| normalModalDemoVisible       | visible of normal Modal | Boolean  | —                            | false       |
| smallModalDemoVisible        | visible of small Modal  | Boolean  | —                            | false       |
| largeModalDemoVisible        | visible of large Modal  | Boolean  | —                            | false       |

### Props

| Property      | Description           | Type           | Accepted Values       | Default     |
|---------------|-----------------------|----------------|-----------------------|-------------|
| visible       | visible of item       | Boolean        | —                     | false       |
| title         | title of item         | String         | —                     | -           |
| size          | size of checked       | String         | —                     | medium      |
| closeVisible  | closeVisible of item  | Boolean        | —                     | false       |

### Events

| Name         | Description                   | Parameters |
|--------------|-------------------------------|------------|
| close        | fire when before close modal. | event      |
| open         | fire when before open modal.  | event      |

</docs>
<template>
<transition name="dialog-fade">
  <div class="mt-modal mt-zindex--middle"
    v-if="visible" @click.self="handleWrapperClick"
    :class="['mt-modal--'+size]">
    <div class="mt-modal__dialog">
      <header class="mt-modal__header">
        <span>{{title}}</span>
        <mt-button
          v-if="closeVisible"
          class="mt-modal__close"
          size="small" width="10" type="subtle"
          @click="$emit('update:visible', !visible)"><mt-icon iconName="close" :hover="false"/></mt-button>
      </header>
      <div class="mt-modal__body">
        <slot></slot>
      </div>
      <footer class="mt-modal__footer" v-if="hasSlotFooter">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</transition>
</template>
<script>
import MtButton from '../button/Button.vue'

export default {
  name: 'mt-modal',
  props: {
    closeVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
    size: {
      type: String,
      require: false,
      default: 'medium'
    },
    title: {
      type: String,
      require: false,
    },
    type: {
      type: String,
      require: false,
      default: 'warning'
    },
    icon: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    MtButton
  },

  data () {
    return {
      hasSlotFooter: false
    }
  },

  computed: {

  },

  methods: {
    handleWrapperClick(){
      this.$emit('update:visible', false)
    },
  },

  mounted () {
		let that = this
		setTimeout(function(){
			that.hasSlotFooter = !!that.$slots['footer']
		})
	},

  watch: {
    visible: function(val, oldVal) {
      if(!val && !!oldVal) {
        this.$emit('close')
      } else {
        this.$emit('open')
      }
    }
  }
}
</script>
<style src="./Modal.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Modal.vue?4c49180a